import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

export function mapDepartmentFromApi(d) {
  return {
    id: d.id,
    branchId: d.companyId ? String(d.companyId) : '',
    branch: d.companyName ?? '',
    parentDepartmentId: d.parentDepartmentId != null ? String(d.parentDepartmentId) : '',
    parentName: d.parentName ?? '',
    name: d.name ?? '',
    description: d.description ?? '',
    managerUserId: d.managerUserId ?? '',
    managerName: d.managerName ?? '',
    isActive: !!d.isActive,
    subDepartmentsCount: Number(d.subDepartmentsCount ?? 0),
  };
}

export function mapDepartmentFormToPayload(form) {
  const parentRaw = form.parentDepartmentId?.trim?.() ?? '';
  const parentId = parentRaw === '' ? null : Number(parentRaw);
  const mgr = form.managerUserId?.trim?.() ?? '';
  return {
    companyId: Number(form.branchId),
    parentDepartmentId: Number.isFinite(parentId) && parentId > 0 ? parentId : null,
    name: form.name?.trim() ?? '',
    description: form.description?.trim() || null,
    managerUserId: mgr === '' ? null : mgr,
    isActive: !!form.isActive,
  };
}

export async function fetchDepartments() {
  const res = await fetch(`${API_BASE}/api/departments`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل الإدارات'));
  const list = Array.isArray(data) ? data : [];
  return list.map(mapDepartmentFromApi);
}

export async function fetchDepartmentManagerCandidates(companyId) {
  const q = new URLSearchParams({ companyId: String(companyId) });
  const res = await fetch(`${API_BASE}/api/departments/manager-candidates?${q}`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل قائمة المسؤولين'));
  const list = Array.isArray(data) ? data : [];
  return list.map((x) => ({ id: x.id ?? '', name: x.name ?? x.id ?? '' }));
}

export async function fetchDepartmentById(id) {
  const res = await fetch(`${API_BASE}/api/departments/${id}`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل بيانات الإدارة'));
  return mapDepartmentFromApi(data);
}

export async function createDepartment(payload) {
  const res = await fetch(`${API_BASE}/api/departments`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إضافة الإدارة'));
  return mapDepartmentFromApi(data);
}

export async function updateDepartment(id, payload) {
  const res = await fetch(`${API_BASE}/api/departments/${id}/edit`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر حفظ التعديلات'));
  return mapDepartmentFromApi(data);
}

export async function deleteDepartment(id) {
  const res = await fetch(`${API_BASE}/api/departments/${id}`, {
    method: 'DELETE',
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(messageFromErrorBody(data, 'تعذر حذف الإدارة'));
  }
}
